import { withGroupingWindow } from 'common/utils';
import { axios } from 'libs';
import {
  EXIBIR_ORDEM_CRESCENTE_ANEXO,
  EXIBIR_ORDEM_GERAL_ANEXO,
  EXIGE_CAPTCHA_PARA_CRIAR_PROCESSO_EXTERNO,
  NAO_DEMONSTRA_AVISO_PROCESSO_MESMO_ASSUNTO_REQUERENTE,
  OCULTAR_LOGIN_OXY_CIDADAO,
  PERMITE_SOLICITACAO_ASSINATURA_USUARIO_DUPLICADA_ARQUIVO,
  TAMANHO_MAXIMO_ARQUIVOS_EXTERNO
} from 'pages/parametros/Parametros';

const resource = '/parametros';

// Códigos liberados anonimamente em PUBLIC_ENDPOINTS (ProtocoloPublicEndpointsHelper.java)
// como rotas individuais de /api/parametros/{id} — não passam pelo agrupamento de
// /valores porque esse batch endpoint não está na lista de rotas públicas.
const PUBLIC_PARAMETRO_CODIGOS = [
  TAMANHO_MAXIMO_ARQUIVOS_EXTERNO,
  NAO_DEMONSTRA_AVISO_PROCESSO_MESMO_ASSUNTO_REQUERENTE,
  PERMITE_SOLICITACAO_ASSINATURA_USUARIO_DUPLICADA_ARQUIVO,
  EXIBIR_ORDEM_CRESCENTE_ANEXO,
  EXIBIR_ORDEM_GERAL_ANEXO,
  OCULTAR_LOGIN_OXY_CIDADAO,
  EXIGE_CAPTCHA_PARA_CRIAR_PROCESSO_EXTERNO
];

export const findParametros = parametros => {
  return axios.post(`${resource}/valores`, parametros).then(response => ({
    ...response,
    data: parametros.map(codigo => {
      const parametro = response.data.find(
        parametro => parametro.id === codigo
      );

      if (!parametro) {
        throw new Error(
          `Parâmetro de código ${codigo} não encontrado na resposta.`
        );
      }

      return parametro;
    })
  }));
};

const findParametroAgrupado = withGroupingWindow(findParametros);

export const findParametro = codigo =>
  PUBLIC_PARAMETRO_CODIGOS.includes(codigo)
    ? axios.get(`${resource}/${codigo}`)
    : findParametroAgrupado(codigo);

export const findAllParametros = () => {
  return axios.get(`${resource}/lista`);
};

export const save = parametros => {
  return axios.post(`${resource}/update-lista`, parametros);
};

export const validarGrupo = id => {
  return axios.get(`${resource}/validar-grupo/${id}`);
};
